/** @format */

import { createContext, useContext, useEffect, useState } from "react";
import queryString from "query-string";
import { parseJwt } from "../utils";

const SessionContext = createContext();

export function SessionProvider({ children }) {
  const [session, setSession] = useState({
    idvarejista: "",
    xapikey: "",
    cpfcnpj: "",
    idloja: "",
    redirect: "",
    latitude: "",
    longitude: "",
    isdev: "",
  });

  useEffect(() => {
    if (window.document.location.search === "") {
      const sessionStorage = localStorage.getItem("@Session::");
      if (sessionStorage) {
        setSession(JSON.parse(sessionStorage));
      }
    }
  }, []);

  function getSession(search) {
    const sessionUrl = queryString.parse(search);

    if (Object.keys(sessionUrl).length > 0) {
      if (
        session.idvarejista === "" &&
        session.xapikey === "" &&
        session.cpfcnpj === "" &&
        session.idloja === ""
      ) {
        if (sessionUrl.token) {
          const payload = parseJwt(sessionUrl.token);
          sessionUrl.cpfcnpj = payload.cpfcnpj || payload.cpf;
          sessionUrl.idvarejista =
            payload.idvarejista || sessionUrl.idvarejista;
          sessionUrl.idlojaexterno = payload.centro_distribuicao_id || sessionUrl.idlojaexterno || 0;
          sessionUrl.xapikey = payload["x-api-key"] || sessionUrl.xapikey;
        }

        setSession(sessionUrl);
        localStorage.setItem("@Session::", JSON.stringify(sessionUrl));
      }
    }
  }

  return (
    <SessionContext.Provider value={{ session, setSession, getSession }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  const context = useContext(SessionContext);

  const { session, setSession, getSession } = context;

  return { session, setSession, getSession };
}
